import { CountryCode, SMSGroup, SMSGroupMember, SMSScheduledMessage } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/SMS/SMSGroup/SMSGroup.Controller.ts
export class SMSGroupsAPI {
  static async getSMSGroups(orgId: number) {
    return APIService.Server.get<SMSGroup[]>(`/sms-groups/${orgId}/groups`);
  }
  static async createSMSGroup(smsGroup: Partial<SMSGroup>) {
    return APIService.Server.post<SMSGroup>("/sms-groups/group", smsGroup);
  }
  static async getSMSGroupMembers(orgId: number, groupSlug: string) {
    return APIService.Server.get<SMSGroupMember[]>(`/sms-groups/${orgId}/group/${groupSlug}/members`);
  }
  static async getCampaignMessages(orgId: number) {
    return APIService.Server.get<SMSScheduledMessage[]>(`/sms-groups/${orgId}/campaign-messages`);
  }
  // TODO: Implement these methods
  static async addSMSGroupMember(smsGroupMember: Partial<SMSGroupMember>, countryCodes: CountryCode[]) {
    throw new Error("Method not implemented.");

    return APIService.Server.post<SMSGroupMember>("/sms-groups/member", { ...smsGroupMember, countryCodes });
  }
  static async removeFromAllGroups(orgId: number, phoneNumber: string) {
    throw new Error("Method not implemented.");

    // return APIService.Server.delete(`/sms-groups/${orgId}/member/${phoneNumber}`);
  }
  static async removeFromGroup(orgId: number, phoneNumber: string, groupSlug: string) {
    throw new Error("Method not implemented.");

    // return APIService.Server.delete(`/sms-groups/member`, { data: smsGroupMember });
  }
}
